import styled from '@emotion/styled';
import { Typography } from '@ui-components/neo.tax';

export const Percentage = styled(Typography)({
  textDecoration: 'underline',
  cursor: 'pointer',
});
